import { PageTitle } from '@/components/seo/page-title';
import { PasswordScreen } from '@/screens/settings/password-screen';
import React from 'react';

export default function PasswordRoute() {
  return (
    <>
      <PageTitle title="Password" />
      <PasswordScreen />
    </>
  );
}
